import { Button, TextBlock } from '../../atoms';
import React from 'react';
import useStyles from './ErrorModal.styles';

interface IErrorModalProps {
  open?: boolean;
  headerText: string;
  text: string;
  buttonText: string;
  buttonSize?: 'small' | 'medium' | 'large';
  handleButtonClick: () => void;
}

export const ErrorModal: React.FC<IErrorModalProps> = ({
  open,
  headerText,
  text,
  buttonText,
  buttonSize,
  handleButtonClick,
}) => {
  const classes = useStyles();
  return (
    <>
      {open && (
        <div className={classes.root}>
          <div className={classes.titleContainer}>
            <div className={classes.title}>
              <TextBlock type="titleErrorModalTB" text={headerText} />
            </div>
          </div>
          <div className={classes.textContainer}>
            <TextBlock type="textErrorModalTB" text={text} />
          </div>
          <div className={classes.buttons}>
            <Button
              onAction={() => handleButtonClick()}
              color="blue"
              size={buttonSize}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
